import { ShieldCheck } from "lucide-react";

export const GUARANTEE_TEXT = "Se entro 14 giorni dall'inizio del percorso senti che non fa per te, ti rimborso l'intera quota. Unica condizione: aver partecipato agli incontri e seguito il programma previsto in quei giorni.";

export const Guarantee = ({ testid, className = "" }) => (
  <div data-testid={testid} className={`flex items-start gap-4 border border-[#98bfa2] bg-[#0b120e] p-6 md:p-7 ${className}`}>
    <ShieldCheck size={32} className="shrink-0 text-[#c4dcca]" aria-hidden="true" />
    <div>
      <p className="font-display text-2xl font-900 uppercase leading-none text-[#f4f7f5] md:text-3xl">
        Soddisfatto <span className="text-[#c4dcca]">o rimborsato.</span>
      </p>
      <p className="mt-1 font-mono text-xs uppercase tracking-widest text-[#98bfa2]">Garanzia 14 giorni</p>
      <p className="mt-3 text-sm leading-relaxed text-[#a3b1aa] md:text-base">{GUARANTEE_TEXT}</p>
    </div>
  </div>
);

export const GuaranteeBadge = () => (
  <p data-testid="guarantee-badge" className="relative mt-4 inline-flex w-fit items-center gap-2 font-mono text-xs uppercase tracking-widest text-[#c4dcca]">
    <ShieldCheck size={16} aria-hidden="true" /> Soddisfatto o rimborsato · 14 giorni
  </p>
);
